import React, {useEffect} from 'react'
import {IActiveSubscriptionModel} from '../../../models/partner-manage-model/IPackageModel'

type Props = {
  data: IActiveSubscriptionModel
}

const ExpiredCard: React.FC<Props> = ({data}) => {
  useEffect(() => {
    console.log('Use Effect Call')
    return () => {}
  }, [data])

  return (
    <>
      <tr key={data.packageID} className='text-start'>
        <td>
          <span className='text-dark text-hover-primary fs-6'>{data.partnerName}</span>
        </td>
        <td>
          <span className='text-dark text-hover-primary fs-6'>
            {data.packageName ? data.packageName : 'N.A'}
          </span>
        </td>
        <td>
          <span className='text-dark text-hover-primary fs-6'>
            {data.packageExpireDate === '01-Jan-1900' ? 'N.A' : data.packageExpireDate}
          </span>
        </td>
        <td>
          <span className='text-dark text-hover-primary d-block fs-6'>{data.durationDays}</span>
        </td>
        <td>
          <span className='d-block fs-6'>
            {(() => {
              if (!data.packageExpireDate) return 'N.A'
              const today: any = new Date()
              const expireDate: any = new Date(data.packageExpireDate)
              // remove time part
              today.setHours(0, 0, 0, 0)
              expireDate.setHours(0, 0, 0, 0)
              const diffDays = Math.floor((expireDate - today) / (1000 * 60 * 60 * 24))
              if (diffDays < 0) {
                return (
                  <span className='text-danger'>{`Plan expired ${Math.abs(
                    diffDays
                  )} days before`}</span>
                )
              } else if (diffDays > 0) {
                return <span>{`Plan expired after ${diffDays} days`}</span>
              } else {
                return <span className='text-warning'>Plan expires today</span>
              }
            })()}
          </span>
        </td>

        <td>
          <span className='text-dark text-hover-primary d-block fs-6'>{data.price}</span>
        </td>
      </tr>
    </>
  )
}

export {ExpiredCard}
